/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

const Heading = ({ className, children, tag, ...props }) => (
  <div className="flex items-center" {...props}>
    <h3 className={clsx("text-xl leading-relaxed font-semibold mr-4", className)}>{children}</h3>
    {tag}
  </div>
);

const Description = ({ className, children }) => (
  <div className={clsx("text-sm leading-snug mt-2", className)}>{children}</div>
);

const Header = ({ className, headingText, descriptionText, children, tag, onClick }) => (
  <div
    className={clsx("", !clsx(className).match(/(p[xy]?)-(\d+)/) && "p-4", className)}
    onClick={onClick}
  >
    {headingText && <Heading tag={tag}>{headingText}</Heading>}

    {descriptionText && <Description>{descriptionText}</Description>}

    {children}
  </div>
);

const Content = ({ className, children }) => (
  <div className={clsx("p-6", className)}>{children}</div>
);

const Card = ({
  children,
  className,
  content,
  descriptionText,
  header,
  headingText,
  tag,
  ...props
}) => (
  <div className={clsx("rounded shadow bg-white", className)} {...props}>
    {header}

    {!header && (headingText || descriptionText) && (
      <Header headingText={headingText} descriptionText={descriptionText} tag={tag} />
    )}

    {content && <Content>{content}</Content>}

    {children}
  </div>
);

Heading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.node,
};

Heading.defaultProps = {
  children: undefined,
  className: undefined,
  tag: undefined,
};

Description.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Description.defaultProps = {
  children: undefined,
  className: undefined,
};

Header.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  descriptionText: PropTypes.string,
  headingText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  tag: PropTypes.node,
};

Header.defaultProps = {
  children: undefined,
  className: undefined,
  descriptionText: undefined,
  headingText: undefined,
  onClick: undefined,
  tag: undefined,
};

Content.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Content.defaultProps = {
  children: undefined,
  className: undefined,
};

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  content: PropTypes.string,
  descriptionText: PropTypes.string,
  header: PropTypes.node,
  headingText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tag: PropTypes.node,
};

Card.defaultProps = {
  children: undefined,
  className: undefined,
  content: undefined,
  descriptionText: undefined,
  header: undefined,
  headingText: undefined,
  tag: undefined,
};

Card.Content = Content;
Card.Description = Description;
Card.Header = Header;
Card.Heading = Heading;

export default Card;
